import moment from 'moment'

/**
 * Returns the grad year for the target date
 * @param {string|moment|date} date - (optional) target date to evaluate 
 * @returns moment
 */
const getGradYear = (date) => {
    const dateMoment = moment(date)
    return dateMoment.year() + ( dateMoment.month() >= 5 ? 1 : 0)
}

export default getGradYear